// import React, { useState, useEffect } from "react";
// import Filter from "./Filter";
// import ProductCardWrapper from "./ProductCardWrapper";
// import useSWR from "swr";
// import { fetcher, BASE_URL } from "../../../lib/apiConstants";
// import { useSearchParams } from "react-router-dom";

// const ProductsAndFilter = () => {
//   const [searchParams, setSearchParams] = useSearchParams();
//   const urlCategory = searchParams.get("category") || "";

//   const {
//     data: products,
//     isLoading: productsLoading,
//     error: productsError,
//     mutate: mutateProducts,
//   } = useSWR("/products/", fetcher, {
//     errorRetryCount: 3,
//     errorRetryInterval: 1000,
//     revalidateOnFocus: true,
//     revalidateOnReconnect: true,
//     dedupingInterval: 2000,
//   });

//   const cardData = products
//     ?.map((item) => {
//       return {
//         id: item?.id,
//         title: item?.title,
//         info: item?.short_desc,
//         image: `${BASE_URL}${item?.image?.url}`,
//         offerPrice: item?.price?.level_2_price,
//         actualPrice: item?.price?.level_1_price,
//         category: item?.category?.toLowerCase(),
//         slug: item?.slug,
//         readers_icons: item?.readers_icons,
//         owner: item?.owner,
//       };
//     })
//     .sort((a, b) => {
//       const aIsSicunet = a?.owner?.toLowerCase() === "sicunet";
//       const bIsSicunet = b?.owner?.toLowerCase() === "sicunet";
//       if (aIsSicunet && !bIsSicunet) return -1;
//       if (!aIsSicunet && bIsSicunet) return 1;

//       const aHasPL = a?.title?.toUpperCase().includes("PL");
//       const bHasPL = b?.title?.toUpperCase().includes("PL");
//       if (aHasPL && !bHasPL) return -1;
//       if (!bHasPL && aHasPL) return 1;

//       if (!aHasPL && !bHasPL) {
//         if (a.id === 127) return -1;
//         if (b.id === 127) return 1;
//         if (a.id === 79) return 1;
//         if (b.id === 79) return -1;
//       }

//       return 0;
//     });

//   const [pageNo, setPageNo] = useState(1);
//   const [filteredProducts, setFilteredProducts] = useState(cardData);
//   const [selectedCategory, setSelectedCategory] = useState(urlCategory);
//   const [searchQuery, setSearchQuery] = useState("");

//   useEffect(() => {
//     setSelectedCategory(urlCategory);
//   }, [urlCategory]);

//   useEffect(() => {
//     setFilteredProducts(cardData);
//   }, [products]);

//   const PRODUCTS_PER_PAGE = 15;

//   const filterProducts = () => {
//     let products = productsLoading ? [] : cardData ? [...cardData] : [];
//     if (selectedCategory.length === 0) {
//       products = cardData ? [...cardData] : [];
//     } else {
//       products = products?.filter((product) =>
//         selectedCategory.includes(product.category)
//       );
//     }
//     if (searchQuery) {
//       products = products?.filter((product) =>
//         product.title.toLowerCase().includes(searchQuery.toLowerCase())
//       );
//     }

//     setFilteredProducts(products || []);
//     setPageNo(1);
//   };

//   const handlePageChange = (page) => {
//     setPageNo(page);
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   const getPaginatedProducts = () => {
//     const startIndex = (pageNo - 1) * PRODUCTS_PER_PAGE;
//     return filteredProducts?.slice(startIndex, startIndex + PRODUCTS_PER_PAGE);
//   };

//   const handleFilterChange = (category) => {
//     setSelectedCategory(category);
//   };

//   const handleSearchChange = (value) => {
//     setSearchQuery(value);
//   };

//   const handleSortChange = (value) => {
//     const sortedData = [...filteredProducts]?.sort((a, b) => {
//       const startsWithNumber = (str) => /^\d/.test(str);
//       const aStartsWithNumber = startsWithNumber(a.title);
//       const bStartsWithNumber = startsWithNumber(b.title);

//       if (aStartsWithNumber && !bStartsWithNumber) return -1;
//       else if (!aStartsWithNumber && bStartsWithNumber) return 1;

//       if (value === "asc") return a.title.localeCompare(b.title);
//       else if (value === "desc") return b.title.localeCompare(a.title);
//       return 0;
//     });

//     const finalSorted = sortedData.sort((a, b) => {
//       const aHasPL = a?.title?.toUpperCase().includes("PL");
//       const bHasPL = b?.title?.toUpperCase().includes("PL");
//       if (aHasPL && !bHasPL) return -1;
//       if (!aHasPL && bHasPL) return 1;
//       return 0;
//     });

//     setFilteredProducts(finalSorted);
//   };

//   const handleRetry = async () => {
//     try {
//       await mutateProducts();
//     } catch (error) {
//       console.error("Retry failed:", error);
//     }
//   };

//   useEffect(() => {
//     filterProducts();
//   }, [selectedCategory, searchQuery]);

//   useEffect(() => {
//     if (productsError) {
//       console.error("Products fetch error:", productsError);
//     }
//   }, [productsError]);

//   // Amazon-style Pagination Component
//   const AmazonPagination = () => {
//     const totalPages = Math.ceil(filteredProducts.length / PRODUCTS_PER_PAGE);

//     const getPageNumbers = () => {
//       const pages = [];
//       const maxVisible = 5;

//       if (totalPages <= maxVisible + 2) {
//         // Show all pages if total is small
//         for (let i = 1; i <= totalPages; i++) {
//           pages.push(i);
//         }
//       } else {
//         // Always show first page
//         pages.push(1);

//         if (pageNo > 3) {
//           pages.push("...");
//         }

//         // Show pages around current
//         const start = Math.max(2, pageNo - 1);
//         const end = Math.min(totalPages - 1, pageNo + 1);

//         for (let i = start; i <= end; i++) {
//           if (!pages.includes(i)) {
//             pages.push(i);
//           }
//         }

//         if (pageNo < totalPages - 2) {
//           pages.push("...");
//         }

//         // Always show last page
//         if (!pages.includes(totalPages)) {
//           pages.push(totalPages);
//         }
//       }

//       return pages;
//     };

//     return (
//       <div className="flex items-center justify-center gap-1 my-8">
//         {/* Previous Button */}
//         <button
//           onClick={() => handlePageChange(pageNo - 1)}
//           disabled={pageNo === 1}
//           className={`px-3 py-1.5 text-sm rounded-sm border transition-all ${
//             pageNo === 1
//               ? "bg-[#f7f8f8] text-[#565959] border-[#d5d9d9] cursor-not-allowed opacity-60"
//               : "bg-white text-[#0F1111] border-[#d5d9d9] hover:bg-[#f7f8f8] hover:border-[#c7c7c7] cursor-pointer"
//           }`}
//         >
//           <span className="flex items-center gap-1">
//             <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
//               <path
//                 d="M7.5 2L3.5 6l4 4"
//                 stroke="currentColor"
//                 strokeWidth="1.5"
//                 fill="none"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//               />
//             </svg>
//             Previous
//           </span>
//         </button>

//         {/* Page Numbers */}
//         {getPageNumbers().map((page, index) => {
//           if (page === "...") {
//             return (
//               <span
//                 key={`ellipsis-${index}`}
//                 className="px-3 py-1.5 text-sm text-[#565959]"
//               >
//                 ...
//               </span>
//             );
//           }

//           return (
//             <button
//               key={page}
//               onClick={() => handlePageChange(page)}
//               className={`min-w-[36px] px-2.5 py-1.5 text-sm rounded-sm border transition-all ${
//                 pageNo === page
//                   ? "bg-[#016FFC] text-white border-[#016FFC] font-medium cursor-default"
//                   : "bg-white text-[#0F1111] border-[#d5d9d9] hover:bg-[#f7f8f8] hover:border-[#c7c7c7] cursor-pointer"
//               }`}
//             >
//               {page}
//             </button>
//           );
//         })}

//         {/* Next Button */}
//         <button
//           onClick={() => handlePageChange(pageNo + 1)}
//           disabled={pageNo === totalPages}
//           className={`px-3 py-1.5 text-sm rounded-sm border transition-all ${
//             pageNo === totalPages
//               ? "bg-[#f7f8f8] text-[#565959] border-[#d5d9d9] cursor-not-allowed opacity-60"
//               : "bg-white text-[#0F1111] border-[#d5d9d9] hover:bg-[#f7f8f8] hover:border-[#c7c7c7] cursor-pointer"
//           }`}
//         >
//           <span className="flex items-center gap-1">
//             Next
//             <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
//               <path
//                 d="M4.5 2l4 4-4 4"
//                 stroke="currentColor"
//                 strokeWidth="1.5"
//                 fill="none"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//               />
//             </svg>
//           </span>
//         </button>
//       </div>
//     );
//   };

//   return (
//     <div className="max-w-[1200px] max-xl:max-w-full mx-auto max-xl:mx-6 py-6 md:py-6 lg:pb-8">
//       {/* Filter Section - Full Width */}
//       <div className="mb-6">
//         <Filter
//           handleChange={handleSortChange}
//           onSearch={handleSearchChange}
//           onChange={handleFilterChange}
//           selectedCategory={selectedCategory}
//         />
//       </div>

//       {/* Products Section */}
//       <div>
//         <ProductCardWrapper
//           displayedProducts={getPaginatedProducts()}
//           productsLoading={productsLoading}
//           productsError={productsError}
//           onRetry={handleRetry}
//         />

//         {/* Amazon-style Pagination */}
//         {filteredProducts?.length > 0 && !productsLoading && !productsError && (
//           <AmazonPagination />
//         )}
//       </div>
//     </div>
//   );
// };

// export default ProductsAndFilter;
// import React, { useState, useEffect } from "react";
// import Filter from "./Filter";
// import ProductCardWrapper from "./ProductCardWrapper";
// import useSWR from "swr";
// import { fetcher, BASE_URL } from "../../../lib/apiConstants";
// import { useSearchParams } from "react-router-dom";

// const ProductsAndFilter = () => {
//   const [searchParams, setSearchParams] = useSearchParams();
//   const urlCategory = searchParams.get("category") || "";

//   const {
//     data: products,
//     isLoading: productsLoading,
//     error: productsError,
//     mutate: mutateProducts,
//   } = useSWR("/products/", fetcher, {
//     errorRetryCount: 3,
//     errorRetryInterval: 1000,
//     revalidateOnFocus: true,
//     revalidateOnReconnect: true,
//     dedupingInterval: 2000,
//   });

//   // Custom sorting function to maintain proper order
//   const customSort = (a, b) => {
//     // 1. Sicunet products first
//     const aIsSicunet = a?.owner?.toLowerCase() === "sicunet";
//     const bIsSicunet = b?.owner?.toLowerCase() === "sicunet";
//     if (aIsSicunet && !bIsSicunet) return -1;
//     if (!aIsSicunet && bIsSicunet) return 1;

//     // Extract base number and suffix from title (e.g., "1DMPL" -> base: 1, hasPL: true)
//     const extractTitleInfo = (title) => {
//       const match = title?.match(/^(\d+)([A-Z]*)(PL)?/i);
//       if (match) {
//         return {
//           base: parseInt(match[1]) || 0,
//           prefix: match[2] || "",
//           hasPL: (match[3] || "").toUpperCase() === "PL",
//         };
//       }
//       return { base: 999, prefix: "", hasPL: false };
//     };

//     const aInfo = extractTitleInfo(a.title);
//     const bInfo = extractTitleInfo(b.title);

//     // 2. Sort by base number first
//     if (aInfo.base !== bInfo.base) {
//       return aInfo.base - bInfo.base;
//     }

//     // 3. Within same base number, PL versions come first
//     if (aInfo.hasPL && !bInfo.hasPL) return -1;
//     if (!aInfo.hasPL && bInfo.hasPL) return 1;

//     // 4. Special handling for 2DM (id: 127) to come after 2DMPL
//     if (a.id === 127 && b.title.includes("2DMPL")) return 1;
//     if (b.id === 127 && a.title.includes("2DMPL")) return -1;

//     // 5. Keep original order for everything else
//     return 0;
//   };

//   const cardData = products
//     ?.map((item) => {
//       return {
//         id: item?.id,
//         title: item?.title,
//         info: item?.short_desc,
//         image: `${BASE_URL}${item?.image?.url}`,
//         offerPrice: item?.price?.level_2_price,
//         actualPrice: item?.price?.level_1_price,
//         category: item?.category?.toLowerCase(),
//         slug: item?.slug,
//         readers_icons: item?.readers_icons,
//         owner: item?.owner,
//       };
//     })
//     .sort(customSort);

//   const [pageNo, setPageNo] = useState(1);
//   const [filteredProducts, setFilteredProducts] = useState(cardData);
//   const [selectedCategory, setSelectedCategory] = useState(urlCategory);
//   const [searchQuery, setSearchQuery] = useState("");

//   useEffect(() => {
//     setSelectedCategory(urlCategory);
//   }, [urlCategory]);

//   useEffect(() => {
//     setFilteredProducts(cardData);
//   }, [products]);

//   const PRODUCTS_PER_PAGE = 15;

//   const filterProducts = () => {
//     let products = productsLoading ? [] : cardData ? [...cardData] : [];
//     if (selectedCategory.length === 0) {
//       products = cardData ? [...cardData] : [];
//     } else {
//       products = products?.filter((product) =>
//         selectedCategory.includes(product.category)
//       );
//     }
//     if (searchQuery) {
//       products = products?.filter((product) =>
//         product.title.toLowerCase().includes(searchQuery.toLowerCase())
//       );
//     }

//     // Apply the same custom sort to filtered products
//     products = products.sort(customSort);

//     setFilteredProducts(products || []);
//     setPageNo(1);
//   };

//   const handlePageChange = (page) => {
//     setPageNo(page);
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   const getPaginatedProducts = () => {
//     const startIndex = (pageNo - 1) * PRODUCTS_PER_PAGE;
//     return filteredProducts?.slice(startIndex, startIndex + PRODUCTS_PER_PAGE);
//   };

//   const handleFilterChange = (category) => {
//     setSelectedCategory(category);
//   };

//   const handleSearchChange = (value) => {
//     setSearchQuery(value);
//   };

//   const handleSortChange = (value) => {
//     const sortedData = [...filteredProducts]?.sort((a, b) => {
//       const startsWithNumber = (str) => /^\d/.test(str);
//       const aStartsWithNumber = startsWithNumber(a.title);
//       const bStartsWithNumber = startsWithNumber(b.title);

//       if (aStartsWithNumber && !bStartsWithNumber) return -1;
//       else if (!aStartsWithNumber && bStartsWithNumber) return 1;

//       if (value === "asc") return a.title.localeCompare(b.title);
//       else if (value === "desc") return b.title.localeCompare(a.title);
//       return 0;
//     });

//     // Reapply custom sort after user sorting
//     const finalSorted = sortedData.sort(customSort);

//     setFilteredProducts(finalSorted);
//   };

//   const handleRetry = async () => {
//     try {
//       await mutateProducts();
//     } catch (error) {
//       console.error("Retry failed:", error);
//     }
//   };

//   useEffect(() => {
//     filterProducts();
//   }, [selectedCategory, searchQuery]);

//   useEffect(() => {
//     if (productsError) {
//       console.error("Products fetch error:", productsError);
//     }
//   }, [productsError]);

//   // Amazon-style Pagination Component
//   const AmazonPagination = () => {
//     const totalPages = Math.ceil(filteredProducts.length / PRODUCTS_PER_PAGE);

//     const getPageNumbers = () => {
//       const pages = [];
//       const maxVisible = 5;

//       if (totalPages <= maxVisible + 2) {
//         for (let i = 1; i <= totalPages; i++) {
//           pages.push(i);
//         }
//       } else {
//         pages.push(1);

//         if (pageNo > 3) {
//           pages.push("...");
//         }

//         const start = Math.max(2, pageNo - 1);
//         const end = Math.min(totalPages - 1, pageNo + 1);

//         for (let i = start; i <= end; i++) {
//           if (!pages.includes(i)) {
//             pages.push(i);
//           }
//         }

//         if (pageNo < totalPages - 2) {
//           pages.push("...");
//         }

//         if (!pages.includes(totalPages)) {
//           pages.push(totalPages);
//         }
//       }

//       return pages;
//     };
//     return (
//       <div className="flex items-center justify-center gap-1 mt-9 mb-6">
//         {/* Previous Button */}
//         <button
//           onClick={() => handlePageChange(pageNo - 1)}
//           disabled={pageNo === 1}
//           className={`px-3 py-1.5 text-sm rounded-sm border transition-all ${
//             pageNo === 1
//               ? "bg-[#f7f8f8] text-[#565959] border-[#d5d9d9] cursor-not-allowed opacity-60"
//               : "bg-white text-[#0F1111] border-[#d5d9d9] hover:bg-[#f7f8f8] hover:border-[#c7c7c7] cursor-pointer"
//           }`}
//         >
//           <span className="flex items-center gap-1">
//             <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
//               <path
//                 d="M7.5 2L3.5 6l4 4"
//                 stroke="currentColor"
//                 strokeWidth="1.5"
//                 fill="none"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//               />
//             </svg>
//             Previous
//           </span>
//         </button>

//         {/* Page Numbers */}
//         {getPageNumbers().map((page, index) => {
//           if (page === "...") {
//             return (
//               <span
//                 key={`ellipsis-${index}`}
//                 className="px-3 py-1.5 text-sm text-[#565959]"
//               >
//                 ...
//               </span>
//             );
//           }

//           return (
//             <button
//               key={page}
//               onClick={() => handlePageChange(page)}
//               className={`min-w-[36px] px-2.5 py-1.5 text-sm rounded-sm border transition-all ${
//                 pageNo === page
//                   ? "bg-[#016FFC] text-white border-[#016FFC] font-medium cursor-default"
//                   : "bg-white text-[#0F1111] border-[#d5d9d9] hover:bg-[#f7f8f8] hover:border-[#c7c7c7] cursor-pointer"
//               }`}
//             >
//               {page}
//             </button>
//           );
//         })}

//         {/* Next Button */}
//         <button
//           onClick={() => handlePageChange(pageNo + 1)}
//           disabled={pageNo === totalPages}
//           className={`px-3 py-1.5 text-sm rounded-sm border transition-all ${
//             pageNo === totalPages
//               ? "bg-[#f7f8f8] text-[#565959] border-[#d5d9d9] cursor-not-allowed opacity-60"
//               : "bg-white text-[#0F1111] border-[#d5d9d9] hover:bg-[#f7f8f8] hover:border-[#c7c7c7] cursor-pointer"
//           }`}
//         >
//           <span className="flex items-center gap-1">
//             Next
//             <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
//               <path
//                 d="M4.5 2l4 4-4 4"
//                 stroke="currentColor"
//                 strokeWidth="1.5"
//                 fill="none"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//               />
//             </svg>
//           </span>
//         </button>
//       </div>
//     );
//   };

//   return (
//     <div className="max-w-[1200px] max-xl:max-w-full mx-auto max-xl:mx-6 py-6 md:py-6 lg:pb-8">
//       {/* Filter Section - Full Width */}
//       <div className="mb-6">
//         <Filter
//           handleChange={handleSortChange}
//           onSearch={handleSearchChange}
//           onChange={handleFilterChange}
//           selectedCategory={selectedCategory}
//         />
//       </div>

//       {/* Products Section */}
//       <div>
//         <ProductCardWrapper
//           displayedProducts={getPaginatedProducts()}
//           productsLoading={productsLoading}
//           productsError={productsError}
//           onRetry={handleRetry}
//         />

//         {/* Amazon-style Pagination */}
//         {filteredProducts?.length > 0 && !productsLoading && !productsError && (
//           <AmazonPagination />
//         )}
//       </div>
//     </div>
//   );
// };

// export default ProductsAndFilter;
// import React, { useState, useEffect, useRef } from "react";
// import Filter from "./Filter";
// import ProductCardWrapper from "./ProductCardWrapper";
// import useSWR from "swr";
// import { fetcher, BASE_URL } from "../../../lib/apiConstants";
// import { useSearchParams } from "react-router-dom";

// const ProductsAndFilter = () => {
//   const [searchParams, setSearchParams] = useSearchParams();
//   const urlCategory = searchParams.get("category") || "";

//   const {
//     data: products,
//     isLoading: productsLoading,
//     error: productsError,
//     mutate: mutateProducts,
//   } = useSWR("/products/", fetcher, {
//     errorRetryCount: 3,
//     errorRetryInterval: 1000,
//     revalidateOnFocus: true,
//     revalidateOnReconnect: true,
//     dedupingInterval: 2000,
//   });

//   // Custom sorting function to maintain proper order
//   const customSort = (a, b) => {
//     // 1. Sicunet products first
//     const aIsSicunet = a?.owner?.toLowerCase() === "sicunet";
//     const bIsSicunet = b?.owner?.toLowerCase() === "sicunet";
//     if (aIsSicunet && !bIsSicunet) return -1;
//     if (!aIsSicunet && bIsSicunet) return 1;

//     // 2. Products with "PL" in title come first (case-insensitive)
//     const aHasPL = a?.title?.toUpperCase().includes("PL");
//     const bHasPL = b?.title?.toUpperCase().includes("PL");
//     if (aHasPL && !bHasPL) return -1;
//     if (!aHasPL && bHasPL) return 1;

//     // Extract base number and suffix from title (e.g., "1DMPL" -> base: 1, hasPL: true)
//     const extractTitleInfo = (title) => {
//       const match = title?.match(/^(\d+)([A-Z]*)(PL)?/i);
//       if (match) {
//         return {
//           base: parseInt(match[1]) || 0,
//           prefix: match[2] || "",
//           hasPL: (match[3] || "").toUpperCase() === "PL",
//         };
//       }
//       return { base: 999, prefix: "", hasPL: false };
//     };

//     const aInfo = extractTitleInfo(a.title);
//     const bInfo = extractTitleInfo(b.title);

//     // 3. Sort by base number first
//     if (aInfo.base !== bInfo.base) {
//       return aInfo.base - bInfo.base;
//     }

//     // 4. Within same base number, PL versions come first
//     if (aInfo.hasPL && !bInfo.hasPL) return -1;
//     if (!aInfo.hasPL && bInfo.hasPL) return 1;

//     // 5. Special handling for 2DM (id: 127) to come after 2DMPL
//     if (a.id === 127 && b.title.includes("2DMPL")) return 1;
//     if (b.id === 127 && a.title.includes("2DMPL")) return -1;

//     // 6. Keep original order for everything else
//     return 0;
//   };

//   const cardData = products
//     ?.map((item) => {
//       return {
//         id: item?.id,
//         title: item?.title,
//         info: item?.short_desc,
//         image: `${BASE_URL}${item?.image?.url}`,
//         offerPrice: item?.price?.level_2_price,
//         actualPrice: item?.price?.level_1_price,
//         category: item?.category?.toLowerCase(),
//         slug: item?.slug,
//         readers_icons: item?.readers_icons,
//         owner: item?.owner,
//       };
//     })
//     .sort(customSort);

//   const [pageNo, setPageNo] = useState(1);
//   const [filteredProducts, setFilteredProducts] = useState([]);
//   const [selectedCategory, setSelectedCategory] = useState(urlCategory);
//   const [searchQuery, setSearchQuery] = useState("");
  
//   // Track previous filter values to detect when filters actually change
//   const prevFilterRef = useRef({ category: urlCategory, search: "" });

//   // Update selectedCategory when URL changes
//   useEffect(() => {
//     setSelectedCategory(urlCategory);
//   }, [urlCategory]);

//   const PRODUCTS_PER_PAGE = 15;

//   // Single useEffect to handle all filtering
//   useEffect(() => {
//     if (!cardData) return;

//     let filtered = [...cardData];

//     // Apply category filter
//     if (selectedCategory && selectedCategory.length > 0) {
//       filtered = filtered.filter((product) =>
//         selectedCategory.includes(product.category)
//       );
//     }

//     // Apply search filter
//     if (searchQuery && searchQuery.trim().length > 0) {
//       filtered = filtered.filter((product) =>
//         product.title.toLowerCase().includes(searchQuery.toLowerCase())
//       );
//     }

//     // Apply custom sort to filtered products
//     filtered = filtered.sort(customSort);

//     setFilteredProducts(filtered);
    
//     // Only reset to page 1 if the filters actually changed (not just cardData)
//     if (
//       prevFilterRef.current.category !== selectedCategory ||
//       prevFilterRef.current.search !== searchQuery
//     ) {
//       setPageNo(1);
//       prevFilterRef.current = { category: selectedCategory, search: searchQuery };
//     }
//   }, [selectedCategory, searchQuery, cardData]);

//   const handlePageChange = (page) => {
//     setPageNo(page);
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   const getPaginatedProducts = () => {
//     const startIndex = (pageNo - 1) * PRODUCTS_PER_PAGE;
//     return filteredProducts?.slice(startIndex, startIndex + PRODUCTS_PER_PAGE);
//   };

//   const handleFilterChange = (category) => {
//     setSelectedCategory(category);
//   };

//   const handleSearchChange = (value) => {
//     setSearchQuery(value);
//   };

//   const handleSortChange = (value) => {
//     const sortedData = [...filteredProducts]?.sort((a, b) => {
//       const startsWithNumber = (str) => /^\d/.test(str);
//       const aStartsWithNumber = startsWithNumber(a.title);
//       const bStartsWithNumber = startsWithNumber(b.title);

//       if (aStartsWithNumber && !bStartsWithNumber) return -1;
//       else if (!aStartsWithNumber && bStartsWithNumber) return 1;

//       if (value === "asc") return a.title.localeCompare(b.title);
//       else if (value === "desc") return b.title.localeCompare(a.title);
//       return 0;
//     });

//     // Reapply custom sort after user sorting
//     const finalSorted = sortedData.sort(customSort);

//     setFilteredProducts(finalSorted);
//   };

//   const handleRetry = async () => {
//     try {
//       await mutateProducts();
//     } catch (error) {
//       console.error("Retry failed:", error);
//     }
//   };

//   useEffect(() => {
//     if (productsError) {
//       console.error("Products fetch error:", productsError);
//     }
//   }, [productsError]);

//   // Amazon-style Pagination Component
//   const AmazonPagination = () => {
//     const totalPages = Math.ceil(filteredProducts.length / PRODUCTS_PER_PAGE);

//     const getPageNumbers = () => {
//       const pages = [];
//       const maxVisible = 5;

//       if (totalPages <= maxVisible + 2) {
//         for (let i = 1; i <= totalPages; i++) {
//           pages.push(i);
//         }
//       } else {
//         pages.push(1);

//         if (pageNo > 3) {
//           pages.push("...");
//         }

//         const start = Math.max(2, pageNo - 1);
//         const end = Math.min(totalPages - 1, pageNo + 1);

//         for (let i = start; i <= end; i++) {
//           if (!pages.includes(i)) {
//             pages.push(i);
//           }
//         }

//         if (pageNo < totalPages - 2) {
//           pages.push("...");
//         }

//         if (!pages.includes(totalPages)) {
//           pages.push(totalPages);
//         }
//       }

//       return pages;
//     };
//     return (
//       <div className="flex items-center justify-center gap-1 mt-9 mb-6">
//         {/* Previous Button */}
//         <button
//           onClick={() => handlePageChange(pageNo - 1)}
//           disabled={pageNo === 1}
//           className={`px-3 py-1.5 text-sm rounded-sm border transition-all ${
//             pageNo === 1
//               ? "bg-[#f7f8f8] text-[#565959] border-[#d5d9d9] cursor-not-allowed opacity-60"
//               : "bg-white text-[#0F1111] border-[#d5d9d9] hover:bg-[#f7f8f8] hover:border-[#c7c7c7] cursor-pointer"
//           }`}
//         >
//           <span className="flex items-center gap-1">
//             <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
//               <path
//                 d="M7.5 2L3.5 6l4 4"
//                 stroke="currentColor"
//                 strokeWidth="1.5"
//                 fill="none"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//               />
//             </svg>
//             Previous
//           </span>
//         </button>

//         {/* Page Numbers */}
//         {getPageNumbers().map((page, index) => {
//           if (page === "...") {
//             return (
//               <span
//                 key={`ellipsis-${index}`}
//                 className="px-3 py-1.5 text-sm text-[#565959]"
//               >
//                 ...
//               </span>
//             );
//           }

//           return (
//             <button
//               key={page}
//               onClick={() => handlePageChange(page)}
//               className={`min-w-[36px] px-2.5 py-1.5 text-sm rounded-sm border transition-all ${
//                 pageNo === page
//                   ? "bg-[#016FFC] text-white border-[#016FFC] font-medium cursor-default"
//                   : "bg-white text-[#0F1111] border-[#d5d9d9] hover:bg-[#f7f8f8] hover:border-[#c7c7c7] cursor-pointer"
//               }`}
//             >
//               {page}
//             </button>
//           );
//         })}

//         {/* Next Button */}
//         <button
//           onClick={() => handlePageChange(pageNo + 1)}
//           disabled={pageNo === totalPages}
//           className={`px-3 py-1.5 text-sm rounded-sm border transition-all ${
//             pageNo === totalPages
//               ? "bg-[#f7f8f8] text-[#565959] border-[#d5d9d9] cursor-not-allowed opacity-60"
//               : "bg-white text-[#0F1111] border-[#d5d9d9] hover:bg-[#f7f8f8] hover:border-[#c7c7c7] cursor-pointer"
//           }`}
//         >
//           <span className="flex items-center gap-1">
//             Next
//             <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
//               <path
//                 d="M4.5 2l4 4-4 4"
//                 stroke="currentColor"
//                 strokeWidth="1.5"
//                 fill="none"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//               />
//             </svg>
//           </span>
//         </button>
//       </div>
//     );
//   };

//   return (
//     <div className="max-w-[1200px] max-xl:max-w-full mx-auto max-xl:mx-6 py-6 md:py-6 lg:pb-8">
//       {/* Filter Section - Full Width */}
//       <div className="mb-6">
//         <Filter
//           handleChange={handleSortChange}
//           onSearch={handleSearchChange}
//           onChange={handleFilterChange}
//           selectedCategory={selectedCategory}
//         />
//       </div>

//       {/* Products Section */}
//       <div>
//         <ProductCardWrapper
//           displayedProducts={getPaginatedProducts()}
//           productsLoading={productsLoading}
//           productsError={productsError}
//           onRetry={handleRetry}
//         />

//         {/* Amazon-style Pagination */}
//         {filteredProducts?.length > 0 && !productsLoading && !productsError && (
//           <AmazonPagination />
//         )}
//       </div>
//     </div>
//   );
// };

// export default ProductsAndFilter;
// import React, { useState, useEffect, useMemo } from "react";
// import Filter from "./Filter";
// import ProductCardWrapper from "./ProductCardWrapper";
// import useSWR from "swr";
// import { fetcher, BASE_URL } from "../../../lib/apiConstants";
// import { useSearchParams } from "react-router-dom";

// const ProductsAndFilter = () => {
//   const [searchParams, setSearchParams] = useSearchParams();
//   const urlCategory = searchParams.get("category") || "";

//   const {
//     data: products,
//     isLoading: productsLoading,
//     error: productsError,
//     mutate: mutateProducts,
//   } = useSWR("/products/", fetcher, {
//     errorRetryCount: 3,
//     errorRetryInterval: 1000,
//     revalidateOnFocus: true,
//     revalidateOnReconnect: true,
//     dedupingInterval: 2000,
//   });

//   // Custom sorting function to maintain proper order
//   const customSort = (a, b) => {
//     // 1. Sicunet products first
//     const aIsSicunet = a?.owner?.toLowerCase() === "sicunet";
//     const bIsSicunet = b?.owner?.toLowerCase() === "sicunet";
//     if (aIsSicunet && !bIsSicunet) return -1;
//     if (!aIsSicunet && bIsSicunet) return 1;

//     // 2. Products with "PL" in title come first (case-insensitive)
//     const aHasPL = a?.title?.toUpperCase().includes("PL");
//     const bHasPL = b?.title?.toUpperCase().includes("PL");
//     if (aHasPL && !bHasPL) return -1;
//     if (!aHasPL && bHasPL) return 1;

//     // Extract base number and suffix from title (e.g., "1DMPL" -> base: 1, hasPL: true)
//     const extractTitleInfo = (title) => {
//       const match = title?.match(/^(\d+)([A-Z]*)(PL)?/i);
//       if (match) {
//         return {
//           base: parseInt(match[1]) || 0,
//           prefix: match[2] || "",
//           hasPL: (match[3] || "").toUpperCase() === "PL",
//         };
//       }
//       return { base: 999, prefix: "", hasPL: false };
//     };

//     const aInfo = extractTitleInfo(a.title);
//     const bInfo = extractTitleInfo(b.title);

//     // 3. Sort by base number first
//     if (aInfo.base !== bInfo.base) {
//       return aInfo.base - bInfo.base;
//     }

//     // 4. Within same base number, PL versions come first
//     if (aInfo.hasPL && !bInfo.hasPL) return -1;
//     if (!aInfo.hasPL && bInfo.hasPL) return 1;

//     // 5. Special handling for 2DM (id: 127) to come after 2DMPL
//     if (a.id === 127 && b.title.includes("2DMPL")) return 1;
//     if (b.id === 127 && a.title.includes("2DMPL")) return -1;

//     // 6. Keep original order for everything else
//     return 0;
//   };

//   // Memoize cardData to prevent infinite loops
//   const cardData = useMemo(() => {
//     if (!products) return [];
//     return products
//       .map((item) => {
//         return {
//           id: item?.id,
//           title: item?.title,
//           info: item?.short_desc,
//           image: `${BASE_URL}${item?.image?.url}`,
//           offerPrice: item?.price?.level_2_price,
//           actualPrice: item?.price?.level_1_price,
//           category: item?.category?.toLowerCase(),
//           slug: item?.slug,
//           readers_icons: item?.readers_icons,
//           owner: item?.owner,
//         };
//       })
//       .sort(customSort);
//   }, [products]);

//   const [pageNo, setPageNo] = useState(1);
//   const [filteredProducts, setFilteredProducts] = useState([]);
//   const [selectedCategory, setSelectedCategory] = useState(urlCategory);
//   const [searchQuery, setSearchQuery] = useState("");

//   // Update selectedCategory when URL changes
//   useEffect(() => {
//     setSelectedCategory(urlCategory);
//   }, [urlCategory]);

//   const PRODUCTS_PER_PAGE = 15;

//   // Filter products whenever filters or data changes
//   useEffect(() => {
//     if (!cardData || cardData.length === 0) {
//       setFilteredProducts([]);
//       return;
//     }

//     let filtered = [...cardData];

//     // Apply category filter
//     if (selectedCategory && selectedCategory.length > 0) {
//       filtered = filtered.filter((product) =>
//         selectedCategory.includes(product.category)
//       );
//     }

//     // Apply search filter
//     if (searchQuery && searchQuery.trim().length > 0) {
//       filtered = filtered.filter((product) =>
//         product.title.toLowerCase().includes(searchQuery.toLowerCase())
//       );
//     }

//     // Apply custom sort to filtered products
//     filtered = filtered.sort(customSort);

//     setFilteredProducts(filtered);
//     setPageNo(1); // Reset to page 1 when filters change
//   }, [selectedCategory, searchQuery, cardData]);

//   const handlePageChange = (page) => {
//     setPageNo(page);
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   const getPaginatedProducts = () => {
//     if (!filteredProducts || filteredProducts.length === 0) return [];
//     const startIndex = (pageNo - 1) * PRODUCTS_PER_PAGE;
//     const endIndex = startIndex + PRODUCTS_PER_PAGE;
//     return filteredProducts.slice(startIndex, endIndex);
//   };

//   const handleFilterChange = (category) => {
//     setSelectedCategory(category);
//   };

//   const handleSearchChange = (value) => {
//     setSearchQuery(value);
//   };

//   const handleSortChange = (value) => {
//     const sortedData = [...filteredProducts]?.sort((a, b) => {
//       const startsWithNumber = (str) => /^\d/.test(str);
//       const aStartsWithNumber = startsWithNumber(a.title);
//       const bStartsWithNumber = startsWithNumber(b.title);

//       if (aStartsWithNumber && !bStartsWithNumber) return -1;
//       else if (!aStartsWithNumber && bStartsWithNumber) return 1;

//       if (value === "asc") return a.title.localeCompare(b.title);
//       else if (value === "desc") return b.title.localeCompare(a.title);
//       return 0;
//     });

//     // Reapply custom sort after user sorting
//     const finalSorted = sortedData.sort(customSort);

//     setFilteredProducts(finalSorted);
//   };

//   const handleRetry = async () => {
//     try {
//       await mutateProducts();
//     } catch (error) {
//       console.error("Retry failed:", error);
//     }
//   };

//   useEffect(() => {
//     if (productsError) {
//       console.error("Products fetch error:", productsError);
//     }
//   }, [productsError]);

//   // Amazon-style Pagination Component
//   const AmazonPagination = () => {
//     const totalPages = Math.ceil(filteredProducts.length / PRODUCTS_PER_PAGE);

//     const getPageNumbers = () => {
//       const pages = [];
//       const maxVisible = 5;

//       if (totalPages <= maxVisible + 2) {
//         for (let i = 1; i <= totalPages; i++) {
//           pages.push(i);
//         }
//       } else {
//         pages.push(1);

//         if (pageNo > 3) {
//           pages.push("...");
//         }

//         const start = Math.max(2, pageNo - 1);
//         const end = Math.min(totalPages - 1, pageNo + 1);

//         for (let i = start; i <= end; i++) {
//           if (!pages.includes(i)) {
//             pages.push(i);
//           }
//         }

//         if (pageNo < totalPages - 2) {
//           pages.push("...");
//         }

//         if (!pages.includes(totalPages)) {
//           pages.push(totalPages);
//         }
//       }

//       return pages;
//     };

//     return (
//       <div className="flex items-center justify-center gap-1 mt-9 mb-6">
//         {/* Previous Button */}
//         <button
//           onClick={() => handlePageChange(pageNo - 1)}
//           disabled={pageNo === 1}
//           className={`px-3 py-1.5 text-sm rounded-sm border transition-all ${
//             pageNo === 1
//               ? "bg-[#f7f8f8] text-[#565959] border-[#d5d9d9] cursor-not-allowed opacity-60"
//               : "bg-white text-[#0F1111] border-[#d5d9d9] hover:bg-[#f7f8f8] hover:border-[#c7c7c7] cursor-pointer"
//           }`}
//         >
//           <span className="flex items-center gap-1">
//             <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
//               <path
//                 d="M7.5 2L3.5 6l4 4"
//                 stroke="currentColor"
//                 strokeWidth="1.5"
//                 fill="none"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//               />
//             </svg>
//             Previous
//           </span>
//         </button>

//         {/* Page Numbers */}
//         {getPageNumbers().map((page, index) => {
//           if (page === "...") {
//             return (
//               <span
//                 key={`ellipsis-${index}`}
//                 className="px-3 py-1.5 text-sm text-[#565959]"
//               >
//                 ...
//               </span>
//             );
//           }

//           return (
//             <button
//               key={page}
//               onClick={() => handlePageChange(page)}
//               className={`min-w-[36px] px-2.5 py-1.5 text-sm rounded-sm border transition-all ${
//                 pageNo === page
//                   ? "bg-[#016FFC] text-white border-[#016FFC] font-medium cursor-default"
//                   : "bg-white text-[#0F1111] border-[#d5d9d9] hover:bg-[#f7f8f8] hover:border-[#c7c7c7] cursor-pointer"
//               }`}
//             >
//               {page}
//             </button>
//           );
//         })}

//         {/* Next Button */}
//         <button
//           onClick={() => handlePageChange(pageNo + 1)}
//           disabled={pageNo === totalPages}
//           className={`px-3 py-1.5 text-sm rounded-sm border transition-all ${
//             pageNo === totalPages
//               ? "bg-[#f7f8f8] text-[#565959] border-[#d5d9d9] cursor-not-allowed opacity-60"
//               : "bg-white text-[#0F1111] border-[#d5d9d9] hover:bg-[#f7f8f8] hover:border-[#c7c7c7] cursor-pointer"
//           }`}
//         >
//           <span className="flex items-center gap-1">
//             Next
//             <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
//               <path
//                 d="M4.5 2l4 4-4 4"
//                 stroke="currentColor"
//                 strokeWidth="1.5"
//                 fill="none"
//                 strokeLinecap="round"
//                 strokeLinejoin="round"
//               />
//             </svg>
//           </span>
//         </button>
//       </div>
//     );
//   };

//   return (
//     <div className="max-w-[1200px] max-xl:max-w-full mx-auto max-xl:mx-6 py-6 md:py-6 lg:pb-8">
//       {/* Filter Section - Full Width */}
//       <div className="mb-6">
//         <Filter
//           handleChange={handleSortChange}
//           onSearch={handleSearchChange}
//           onChange={handleFilterChange}
//           selectedCategory={selectedCategory}
//         />
//       </div>

//       {/* Products Section */}
//       <div>
//         <ProductCardWrapper
//           displayedProducts={getPaginatedProducts()}
//           productsLoading={productsLoading}
//           productsError={productsError}
//           onRetry={handleRetry}
//         />

//         {/* Amazon-style Pagination */}
//         {filteredProducts?.length > 0 && !productsLoading && !productsError && (
//           <AmazonPagination />
//         )}
//       </div>
//     </div>
//   );
// };

// export default ProductsAndFilter;
import React, { useState, useEffect, useMemo } from "react";
import Filter from "./Filter";
import ProductCardWrapper from "./ProductCardWrapper";
import useSWR from "swr";
import { fetcher, BASE_URL } from "../../../lib/apiConstants";
import { useSearchParams } from "react-router-dom";

const ProductsAndFilter = () => {
  const [searchParams] = useSearchParams();
  const urlCategory = searchParams.get("category") || "";

  const {
    data: products,
    isLoading: productsLoading,
    error: productsError,
    mutate: mutateProducts,
  } = useSWR("/products/", fetcher, {
    errorRetryCount: 3,
    errorRetryInterval: 1000,
    revalidateOnFocus: true,
    revalidateOnReconnect: true,
    dedupingInterval: 2000,
  });

  // Custom sorting function to maintain proper order
  const customSort = (a, b) => {
    // 1. Sicunet products first
    const aIsSicunet = a?.owner?.toLowerCase() === "sicunet";
    const bIsSicunet = b?.owner?.toLowerCase() === "sicunet";
    if (aIsSicunet && !bIsSicunet) return -1;
    if (!aIsSicunet && bIsSicunet) return 1;

    // 2. Products with "PL" in title come first (case-insensitive)
    const aHasPL = a?.title?.toUpperCase().includes("PL");
    const bHasPL = b?.title?.toUpperCase().includes("PL");
    if (aHasPL && !bHasPL) return -1;
    if (!aHasPL && bHasPL) return 1;

    // Extract base number and suffix from title (e.g., "1DMPL" -> base: 1, hasPL: true)
    const extractTitleInfo = (title) => {
      const match = title?.match(/^(\d+)([A-Z]*)(PL)?/i);
      if (match) {
        return {
          base: parseInt(match[1]) || 0,
          prefix: match[2] || "",
          hasPL: (match[3] || "").toUpperCase() === "PL",
        };
      }
      return { base: 999, prefix: "", hasPL: false };
    };

    const aInfo = extractTitleInfo(a.title);
    const bInfo = extractTitleInfo(b.title);

    // 3. Sort by base number first
    if (aInfo.base !== bInfo.base) {
      return aInfo.base - bInfo.base;
    }

    // 4. Within same base number, PL versions come first
    if (aInfo.hasPL && !bInfo.hasPL) return -1;
    if (!aInfo.hasPL && bInfo.hasPL) return 1;

    // 5. Special handling for 2DM (id: 127) to come after 2DMPL
    if (a.id === 127 && b.title.includes("2DMPL")) return 1;
    if (b.id === 127 && a.title.includes("2DMPL")) return -1;

    // 6. Keep original order for everything else
    return 0;
  };

  // Memoize cardData to prevent infinite loops
  const cardData = useMemo(() => {
    if (!products) return [];
    return products
      .map((item) => {
        return {
          id: item?.id,
          title: item?.title,
          info: item?.short_desc,
          image: `${BASE_URL}${item?.image?.url}`,
          offerPrice: item?.price?.level_2_price,
          actualPrice: item?.price?.level_1_price,
          category: item?.category?.toLowerCase(),
          slug: item?.slug,
          readers_icons: item?.readers_icons,
          owner: item?.owner,
        };
      })
      .sort(customSort);
  }, [products]);

  const [visibleCount, setVisibleCount] = useState(15); // Initial: 15 products only
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState(urlCategory);
  const [searchQuery, setSearchQuery] = useState("");
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const LOAD_INCREMENT = 15; // Load 15 more each time

  // Update selectedCategory when URL changes
  useEffect(() => {
    setSelectedCategory(urlCategory);
  }, [urlCategory]);

  // Filter products whenever filters or data changes
  useEffect(() => {
    if (!cardData || cardData.length === 0) {
      setFilteredProducts([]);
      return;
    }

    let filtered = [...cardData];

    // Apply category filter
    if (selectedCategory && selectedCategory.length > 0) {
      filtered = filtered.filter((product) =>
        selectedCategory.includes(product.category)
      );
    }

    // Apply search filter
    if (searchQuery && searchQuery.trim().length > 0) {
      filtered = filtered.filter((product) =>
        product.title.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    // Apply custom sort to filtered products
    filtered = filtered.sort(customSort);

    setFilteredProducts(filtered);
    setVisibleCount(15); // Reset to initial 15 when filters change
  }, [selectedCategory, searchQuery, cardData]);

  // Get currently visible products
  const displayedProducts = useMemo(() => {
    return filteredProducts.slice(0, visibleCount);
  }, [filteredProducts, visibleCount]);

  // Manual load more function
  const handleLoadMore = () => {
    setIsLoadingMore(true);
    
    // Smooth loading animation
    setTimeout(() => {
      setVisibleCount((prev) => prev + LOAD_INCREMENT);
      setIsLoadingMore(false);
    }, 300);
  };

  const handleFilterChange = (category) => {
    setSelectedCategory(category);
  };

  const handleSearchChange = (value) => {
    setSearchQuery(value);
  };

  const handleSortChange = (value) => {
    const sortedData = [...filteredProducts]?.sort((a, b) => {
      const startsWithNumber = (str) => /^\d/.test(str);
      const aStartsWithNumber = startsWithNumber(a.title);
      const bStartsWithNumber = startsWithNumber(b.title);

      if (aStartsWithNumber && !bStartsWithNumber) return -1;
      else if (!aStartsWithNumber && bStartsWithNumber) return 1;

      if (value === "asc") return a.title.localeCompare(b.title);
      else if (value === "desc") return b.title.localeCompare(a.title);
      return 0;
    });

    // Reapply custom sort after user sorting
    const finalSorted = sortedData.sort(customSort);
    setFilteredProducts(finalSorted);
  };

  const handleRetry = async () => {
    try {
      await mutateProducts();
    } catch (error) {
      console.error("Retry failed:", error);
    }
  };

  useEffect(() => {
    if (productsError) {
      console.error("Products fetch error:", productsError);
    }
  }, [productsError]);

  const hasMore = visibleCount < filteredProducts.length;
  const remainingCount = filteredProducts.length - visibleCount;

  return (
    <div className="max-w-[1200px] max-xl:max-w-full mx-auto max-xl:mx-6 py-6 md:py-6 lg:pb-2">
      {/* Filter Section */}
      <div className="mb-6">
        <Filter
          handleChange={handleSortChange}
          onSearch={handleSearchChange}
          onChange={handleFilterChange}
          selectedCategory={selectedCategory}
        />
      </div>

      {/* Products Grid */}
      <ProductCardWrapper
        displayedProducts={displayedProducts}
        productsLoading={productsLoading}
        productsError={productsError}
        onRetry={handleRetry}
      />

      {/* Results Info & Load More */}
      {filteredProducts.length > 0 && !productsLoading && !productsError && (
        <>
          {/* Results Counter */}
          <div className="text-center mt-8 text-sm text-[#565959]">
            Showing <span className="font-medium text-[#0F1111]">{visibleCount > filteredProducts.length ? filteredProducts.length : visibleCount}</span> of{" "}
            <span className="font-medium text-[#0F1111]">{filteredProducts.length}</span> products
          </div>

          {/* Load More Button */}
          {hasMore && (
            <div className="mt-6 mb-8">
              <div className="flex flex-col items-center gap-3">
                <button
                  onClick={handleLoadMore}
                  disabled={isLoadingMore}
                  className={`px-10 py-3 min-w-[240px] border border-[#d5d9d9] rounded-sm text-sm font-medium transition-all duration-200 ${
                    isLoadingMore
                      ? "bg-[#f7f8f8] text-[#565959] cursor-not-allowed opacity-70"
                      : "bg-white text-[#0F1111] hover:bg-[#f7f8f8] hover:border-[#c7c7c7] active:bg-[#ededed] shadow-sm hover:shadow-md"
                  }`}
                >
                  {isLoadingMore ? (
                    <span className="flex items-center justify-center gap-2">
                      <svg className="animate-spin h-4 w-4" fill="none" viewBox="0 0 24 24">
                        <circle
                          className="opacity-25"
                          cx="12"
                          cy="12"
                          r="10"
                          stroke="currentColor"
                          strokeWidth="4"
                        />
                        <path
                          className="opacity-75"
                          fill="currentColor"
                          d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                        />
                      </svg>
                      Loading More...
                    </span>
                  ) : (
                    `Load More Products (${remainingCount} remaining)`
                  )}
                </button>

                {/* Helper Text */}
                <p className="text-xs text-[#767676]">
                  Click to load {Math.min(LOAD_INCREMENT, remainingCount)} more products
                </p>
              </div>
            </div>
          )}

          {/* End of Results */}
          {!hasMore && (
            <div className="text-center mt-8 mb-4 py-6 border-t border-[#e7e7e7]">
              <div className="flex flex-col items-center gap-2">
                <svg
                  className="w-12 h-12 text-[#d5d9d9]"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth="1.5"
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
                <p className="text-sm font-medium text-[#0F1111]">
                  You've viewed all {filteredProducts.length} products
                </p>
                <button
                  onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
                  className="mt-2 px-4 py-2 text-sm text-[#016FFC] hover:text-[#C7511F] hover:underline transition-colors"
                >
                  ↑ Back to top
                </button>
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default ProductsAndFilter;